/* =====================================================================
 * Jahrestags-Kalender-Poster Editor (PROJ-30)
 * =====================================================================
 * Reines Text/SVG-Poster (KEIN Foto, KEIN Crop, KEINE Map). Kopiervorlage
 * = ja-geldgeschenk.js (State/Live-Preview, Groessen-/Frame-Picker aus
 * target_product.variants, Cart-Add).
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderKalenderposter() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (gleiche Positionen,
 * cqw-Groessen, Raster-Geometrie, Auto-Fit). Aendert sich der Server,
 * muss dieser Block mitgezogen werden - Werte bewusst identisch.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.KP_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SOFT = '#c8c3ba';
  var SANS = "'Outfit', system-ui, sans-serif";
  var SERIF = "'Playfair Display', Georgia, serif";
  var SCRIPT = "'parlare', 'Great Vibes', cursive";
  var KP_MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli',
                   'August', 'September', 'Oktober', 'November', 'Dezember'];
  var KP_HEART_PATH = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';

  /* ---- Modul-State (eine Section pro -gestalten-Page) ---- */
  var root, stage, sectionId;
  var state = {
    day: 1, month: 1, year: 2026,
    marker: 'herz',            // 'herz' | 'kreis'
    style: 'clean',            // 'clean' | 'verspielt'
    label: '',
    names: 'Emma & Ben',
    deko_heart: true,
    bg_color: '#ffffff',
    c_label: '#28292d',
    c_names: '#28292d',
    paper_size: '30x40',
    variant_id: '',
    product_type: '',
    frame_color: 'brown'
  };

  function kpPad(n) { return (n < 10 ? '0' : '') + n; }

  /* ===================================================================
   * Render-Bausteine - 1:1-Spiegel von jgText/jgFit (Server print-mode.js)
   * =================================================================== */
  function kpText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function kpFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderKalenderposter() (Server)
   * =================================================================== */
  function render() {
    if (!stage) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var ink = INK, soft = SOFT;
    var style = state.style === 'verspielt' ? 'verspielt' : 'clean';
    var marker = state.marker === 'kreis' ? 'kreis' : 'herz';
    var year = parseInt(state.year, 10) || 2026;
    var month = Math.min(12, Math.max(1, parseInt(state.month, 10) || 1));
    var daysInMonth = new Date(year, month, 0).getDate(); // Schaltjahr-sicher
    var day = Math.min(daysInMonth, Math.max(1, parseInt(state.day, 10) || 1));

    // ---- Kopf: Jahr + Monat (stilabhaengig) ----
    var elYear, elMonth;
    if (style === 'clean') {
      elYear = kpText(grid, { content: String(year), x: 50, y: 13, font: SANS, weight: 600, size: 10.5, color: soft, spacing: '0.10em' });
      elMonth = kpText(grid, { content: KP_MONTHS[month - 1], x: 50, y: 21.5, font: SERIF, weight: 600, size: 4.6, color: ink, upper: true, spacing: '0.30em' });
    } else {
      elYear = kpText(grid, { content: String(year), x: 50, y: 17, font: SERIF, weight: 700, size: 17, color: soft, spacing: '0.02em' });
      if (elYear) { elYear.style.zIndex = 4; elYear.style.opacity = '0.55'; }
      elMonth = kpText(grid, { content: KP_MONTHS[month - 1], x: 50, y: 18.5, font: SCRIPT, weight: 400, size: 7.5, color: ink });
      if (elMonth) elMonth.style.zIndex = 5;
    }

    // ---- Tagesraster: 7 Spalten, sequenziell (Referenz-Look) ----
    var cal = document.createElement('div');
    cal.style.cssText = 'position:absolute;left:50%;top:52%;transform:translate(-50%,-50%);' +
      'width:76%;display:grid;grid-template-columns:repeat(7,1fr);row-gap:3.4cqw;column-gap:0.6cqw;z-index:5;';
    var numFont = style === 'clean' ? SANS : SERIF;
    for (var d = 1; d <= daysInMonth; d++) {
      var cell = document.createElement('div');
      cell.style.cssText = 'position:relative;display:flex;align-items:center;justify-content:center;' +
        'font-family:' + numFont + ';font-weight:500;font-size:2.5cqw;color:' + ink + ';' +
        'letter-spacing:0.06em;line-height:1;min-height:4.6cqw;';
      var num = document.createElement('span');
      num.textContent = kpPad(d);
      num.style.cssText = 'position:relative;z-index:2;';
      if (d === day) {
        var mk = document.createElement('span');
        if (marker === 'kreis') {
          mk.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);' +
            'width:4.6cqw;height:4.6cqw;border-radius:50%;background:' + soft + ';z-index:1;';
          num.style.color = '#ffffff';
        } else {
          mk.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-52%);width:7.4cqw;z-index:1;';
          mk.innerHTML = '<svg viewBox="0 0 220 200" style="display:block;width:100%;height:auto;">' +
            '<path d="' + KP_HEART_PATH + '" fill="' + ink + '"/></svg>';
          num.style.color = '#ffffff';
          num.style.fontSize = '2.1cqw';
        }
        cell.appendChild(mk);
      }
      cell.appendChild(num);
      cal.appendChild(cell);
    }
    grid.appendChild(cal);

    // ---- Deko-Herz (klein, zwischen Raster und Label) ----
    if (state.deko_heart) {
      var deko = document.createElement('div');
      deko.style.cssText = 'position:absolute;left:50%;top:78%;transform:translate(-50%,-50%);width:3.4cqw;z-index:5;';
      deko.innerHTML = '<svg viewBox="0 0 220 200" style="display:block;width:100%;height:auto;">' +
        '<path d="' + KP_HEART_PATH + '" fill="' + soft + '"/></svg>';
      grid.appendChild(deko);
    }

    // ---- Label + Namen ----
    var elLabel = kpText(grid, { content: state.label, x: 50, y: 86, font: SANS, weight: 600, size: 2.4, color: state.c_label || ink, upper: true, spacing: '0.26em' });
    var elNames;
    if (style === 'clean') {
      elNames = kpText(grid, { content: state.names, x: 50, y: 90.5, font: SANS, weight: 500, size: 2.6, color: state.c_names || ink, upper: true, spacing: '0.20em' });
    } else {
      elNames = kpText(grid, { content: state.names, x: 50, y: 91, font: SCRIPT, weight: 400, size: 4.6, color: state.c_names || ink });
    }

    stage.innerHTML = '';
    stage.appendChild(grid);

    kpFit(elYear, 88);
    kpFit(elMonth, 90);
    kpFit(elLabel, 90);
    kpFit(elNames, 88);
  }

  /* ===================================================================
   * Eingaben: Datum (Date-Picker), Marker, Stil, Texte, Farben, Toggle
   * =================================================================== */
  function initDateInput() {
    var el = document.getElementById('kp-date');
    if (!el) return;
    function apply() {
      // value = YYYY-MM-DD (Date-Picker verhindert ungueltige Daten komplett)
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.value || '');
      if (!m) return;
      state.year = parseInt(m[1], 10);
      state.month = parseInt(m[2], 10);
      state.day = parseInt(m[3], 10);
      render();
    }
    el.addEventListener('input', apply);
    el.addEventListener('change', apply);
    apply();
  }

  function initToggleRow(selector, key) {
    var btns = root.querySelectorAll(selector);
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        btns.forEach(function (x) { x.classList.remove('current'); });
        b.classList.add('current');
        state[key] = b.getAttribute('data-value');
        render();
      });
    });
    var active = root.querySelector(selector + '.current');
    if (active) state[key] = active.getAttribute('data-value');
  }

  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }

  function initPresetChips() {
    var chips = root.querySelectorAll('.kp-preset-chips [data-preset]');
    var labelInput = document.getElementById('kp-label');
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var val = c.getAttribute('data-preset') || '';
        if (labelInput) labelInput.value = val;
        state.label = val;
        render();
      });
    });
  }

  function initDekoToggle() {
    var cb = document.getElementById('kp-deko-toggle');
    if (!cb) return;
    state.deko_heart = !!cb.checked;
    cb.addEventListener('change', function () { state.deko_heart = cb.checked; render(); });
  }

  function initColorPickers() {
    root.querySelectorAll('.kp-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.kp-paper[data-color]');
    var custom = root.querySelector('.kp-paper-custom');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      if (custom) custom.value = hex;
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
    if (custom) custom.addEventListener('input', function () { setPaper(custom.value); });
  }

  /* Info-Gluehbirne (Stadt-/Sternkarten-Muster, .tab-help) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  /* Tabs (Design / Produkt) - main__switcher-Konvention (editor-tabs.css) */
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 Fotoposter/Wunschwort/Ja-Geldgeschenk-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.kp-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('kp-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Muster ja-geldgeschenk.js: Render-Job synchron anstossen,
   * dann /cart/add.js mit _print_image_url + Config-Properties.
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('kp-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);

        var payload = {
          product: 'kalenderposter',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          bg_color: state.bg_color,
          day: state.day, month: state.month, year: state.year,
          marker: state.marker,
          style: state.style,
          label: state.label,
          names: state.names,
          deko_heart: !!state.deko_heart,
          c_label: state.c_label || INK,
          c_names: state.c_names || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/kalenderposter/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/kalenderposter/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Datum': kpPad(state.day) + '.' + kpPad(state.month) + '.' + state.year,
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': state.paper_size,
          '_produkt': 'kalenderposter'
        };
        if (state.names && state.names.trim()) props['_Namen'] = state.names;
        if (state.label && state.label.trim()) props['_Anlass'] = state.label;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[kalender-poster] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.kp-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('kp-stage-' + sectionId);

    bindField('kp-label', 'label');
    bindField('kp-names', 'names');
    initDateInput();
    initToggleRow('.kp-marker-btn[data-value]', 'marker');
    initToggleRow('.kp-style-btn[data-value]', 'style');
    initPresetChips();
    initDekoToggle();
    initColorPickers();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('kp-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
